import React from 'react';
import { css } from '@emotion/react';

export default function Logo(props) {

    return (
        <h1 css={css`font-size: 24px; margin-bottom: 0;`}>
            Combo Graph
        </h1>
    );
}